import { QueryCache, QueryClient } from '@tanstack/react-query';
import type { UseApiQueryOptions } from '../hooks/useApiQuery';
import { toast } from '@hum/common/src/modules/toast';

export const queryCache = new QueryCache({
  onError: (_data, q) => {
    const options = q.options as UseApiQueryOptions<any, any>;
    if (options.toastsEnabled && options.errorToast) {
      const { errorToast } = options;
      toast.error(errorToast.message, errorToast.options);
    }
  },
  onSuccess: (_data, q) => {
    const options = q.options as UseApiQueryOptions<any, any>;
    if (options.toastsEnabled && options.successToast) {
      const { successToast } = options;
      toast.success(successToast.message, successToast.options);
    }
  },
});

export const queryClient = new QueryClient({ queryCache });
